import * as React from 'react';

import { TagContent } from './tag-content';
import * as Styled from './tag.styles';
import type { DefaultTagProps } from './tag.types';

export const DefaultTag = React.forwardRef<HTMLDivElement, DefaultTagProps>(
  (
    {
      children,
      className,
      fontWeight,
      hideBorder,
      leadingIcon: LeadingIcon,
      maxWidth,
      profile,
      showMiniBadge,
      size = 'medium',
      slotContent,
      trailingIcon: TrailingIcon,
      ...props
    },
    forwardedRef
  ) => {
    return (
      <Styled.DefaultTag
        $fontWeight={fontWeight}
        $hideBorder={hideBorder}
        $size={size}
        className={className}
        data-xds="Tag"
        ref={forwardedRef}
        role="status"
        tabIndex={-1}
        {...props}
      >
        <TagContent
          badgeProps={undefined}
          disabled={false}
          leadingIcon={
            LeadingIcon && (
              <LeadingIcon aria-hidden="true" width={18} height={18} />
            )
          }
          maxWidth={maxWidth}
          profile={profile}
          selected={false}
          showMiniBadge={showMiniBadge}
          size={size}
          slotContent={slotContent}
          trailingIcon={
            TrailingIcon && (
              <TrailingIcon aria-hidden="true" width={18} height={18} />
            )
          }
        >
          {children}
        </TagContent>
      </Styled.DefaultTag>
    );
  }
);

DefaultTag.displayName = 'DefaultTag';
